import { API } from 'aws-amplify';

const API_NAME = 'airtable';

async function cancel(promise) {
  API.cancel(promise);
}

async function create(options, record) {
  const { managedFields, route } = options;
  const records = Array.isArray(record) ? record : [record];

  return API.post(API_NAME, route, {
    body: pickManagedFields(records, managedFields),
  });
}

async function destroy(options, id) {
  const { route } = options;
  const ids = Array.isArray(id) ? id : [id];

  return API.del(API_NAME, route, {
    body: ids,
  });
}

async function find(options, filterByFormula) {
  const { route } = options;

  return API.get(API_NAME, route, {
    queryStringParameters: {
      filterByFormula,
    },
  });
}

async function select(options) {
  const { route } = options;

  return API.get(API_NAME, route, {});
}

async function update(options, record) {
  const { managedFields, route } = options;
  const records = Array.isArray(record) ? record : [record];

  return API.put(API_NAME, route, {
    body: pickManagedFields(records, managedFields),
  });
}

function pickManagedFields(records, names) {
  for (const record of records) {
    const fields = {};

    for (const name of names) {
      if (name in record.fields) {
        fields[name] = record.fields[name];
      }
    }

    record.fields = fields;
  }

  return records;
}

export {
  cancel,
  create,
  destroy,
  find,
  select,
  update,
};
